var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data}},[_c('template',{slot:"operation"},[_c('i',{staticClass:"z-icon delete",on:{"click":function($event){return _vm.deleteItem(_vm.item.id)}}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }